import { render, staticRenderFns } from "./Typography.vue?vue&type=template&id=48a90d05&scoped=true&"
import script from "./Typography.vue?vue&type=script&lang=ts&"
export * from "./Typography.vue?vue&type=script&lang=ts&"
import style0 from "./Typography.vue?vue&type=style&index=0&id=48a90d05&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a90d05",
  null
  
)

export default component.exports